import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ConfigService} from '../../services/config/config.service';
import {GridService} from '../../services/grid/grid.service';
import {TableOfContentsService} from '../../services/toc/table-of-contents.service';

/**
 * Creates the widget bar at the bottom used to open up widget dialog boxes to access the various tools
 */
@Component({
  selector: 'app-widget-bar',
  templateUrl: './widget-bar.component.html',
  styleUrls: ['./widget-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetBarComponent implements OnInit, OnDestroy {

  public toolBarWidth = '60px';
  public widgetNumb = 0;
  public leftArrow = 0.5;
  public rightArrow = 0.5;
  public actualWidth: string;
  public oldWidth: number;
  public left: string;
  private numbVis = 0;
  private targetWidth = 0;
  private mobileAr = [];
  private widgetChangeObserver;

  constructor(public config: ConfigService, private grid: GridService, 
    private toc: TableOfContentsService, private cd: ChangeDetectorRef) { }

  private themeChangeObs;

  ngOnInit() {
    /* if (this.config) {
      console.log('widget-bar call createWidgetobject: ' + this.config.CurrentTheme + 
      ' tools: ' + this.config.tools.length);
      this.setUpThemeWidgets();
    } */
   /*  this.widgetChangeObserver = this.grid.getWidgetChangeObs().subscribe( () => {
      this.cd.detectChanges();
    }); */
    this.themeChangeObs = this.toc.getThemeChangeObs().subscribe(() => {
      //console.log('***widget-bar.component call setUpWidgets: ' + this.config.CurrentTheme);
      this.setUpThemeWidgets();
      this.grid.refreshGrid();
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    //if (this.widgetChangeObserver) { this.widgetChangeObserver.unsubscribe(); }
    if (this.themeChangeObs) { this.themeChangeObs.unsubscribe(); }

  }

  private setUpThemeWidgets() {
    this.config.tools = this.createWidgetObject();
    this.widgetNumb = this.config.tools.length;
    this.targetWidth = this.widgetNumb * 55 + 80;
    this.onResize(window, true);
    this.cd.detectChanges();
  }

  public getTargetWidth() {
    return this.targetWidth;
  }
  /**
   * Adds information the widget bar needs to have in order to operate.
   * It adds things to the config file tool object
   */
  public createWidgetObject() {
    const widgets = [];
    if (this.config) {
      
    // Remove any tools that are excluded in this themes config
    const currTheme = this.config.CurrentTheme;
    if (this.config.tools && this.config.tools.length > 0) {
      if (this.config.appTools && this.config.appTools.length > 0) {
        // config.appTools is the original set of tools for the app. 
        // config.tools are the tools for this theme. Some tools for a theme may be different than the ones at
        //   the app level
        // Set tools to stored appTools
        this.config.tools = []; 
        for (const tool of this.config.appTools) {
          this.config.tools.push(tool);
        }
      }
      else {
        // Set appTools to app level tools  
        this.config.appTools = [];    
        for (const tool of this.config.tools) {
          this.config.appTools.push(tool);
        }
      }
    
      if (this.config.Themes && this.config.Themes[currTheme]) {        
        // Check for excludeTools for current theme
        if (this.config.Themes[currTheme].excludeTools && 
        this.config.Themes[currTheme].excludeTools.length > 0) {
          // Remove excludeTools from tools array
          const themeExcludeTools = this.config.Themes[currTheme].excludeTools;
          themeExcludeTools.forEach((toolID) => {
            const index = this.config.tools.findIndex((tool, index) => {
              if (tool.id.toLowerCase() === toolID.toLowerCase()) {
                //console.log('exclude tool: ' + toolID + ' index: ' + index);
                // turn off this widget if it is on from a previous theme.
                this.grid.widgetOff(tool.id);
                this.config.tools.splice(index, 1);
                return true;
              }
            });
          });
      }
      if (this.config.Themes[currTheme].replaceTools && 
        this.config.Themes[currTheme].replaceTools.length > 0) {
          // Replace tools for this theme
          const themeReplaceTools = this.config.Themes[currTheme].replaceTools;
          themeReplaceTools.forEach((toolObj) => {
            const index = this.config.tools.findIndex((tool, index) => {
              if (tool.id.toLowerCase() === toolObj.id.toLowerCase()) {
                //console.log('replace tool: ' + toolObj.id + ' index: ' + index);
                this.config.tools.splice(index, 1, toolObj);
                return true;
              }
            });
          });
      }
    }
    // Close any specified tools that may have been on from a previous theme
    if (this.config && this.config.closeToolsOnThemeSwitch) {
      this.config.closeToolsOnThemeSwitch.forEach((toolID) => {
        this.grid.widgetOff(toolID);
      });
    }

    for (let i = 0; i < this.config.tools.length; i++) {
      let open = 'widget-off';
      let grid = false;
      if (this.config.tools[i].openByDefault) {
        open = 'widget-on';
        grid = true;
      }
      const tmp = {
        id: this.config.tools[i].id,
        name: this.config.tools[i].name,
        visible: 'visible',
        width: '45px',
        iconWidth: '20px',
        padding: '15px',
        margin: '5px',
        position: i + 1,
        message: this.config.tools[i].message,
        email: this.config.tools[i].email,
        survey: this.config.tools[i].survey,
        status: open,
        grid: grid,
        icon: './assets/widget-bar/' + this.config.tools[i].id + '-icon.png',
        button: 'vis'};
      widgets.push(tmp);
    }
  }
  }
    return widgets;
  }

  /**
   * Event binding that moves the widget buttons to the right on user click
   * @param index: widget index
   */
  public goRight(index?: number) {
    if (!index) {
      // checks to see if the right most widget is turned off because mobile
      if ((window.innerWidth > 600 || window.innerHeight > 600)) {
        // if its not, then it checks to see if the last widget in the list is hidden
        if (this.config.tools[this.config.tools.length - 1].visible === 'hidden') {
          // if it is, it turns on one widget
          for (let i = 0; i < this.config.tools.length; i++) {
            this.config.tools[i].position--;
            if (this.config.tools[i].position <= 0) {
              this.animateOff(i);
            } else if (this.config.tools[i].position === (this.numbVis)) {
              this.turnOn(i);
            }
          }
        }
      } else if (!this.mobileOff(this.config.tools.length - 1)) {
        // if its not, then it checks to see if the last widget in the list is hidden
        if (this.config.tools[this.config.tools.length - 1].visible === 'hidden') {
          // if it is, it turns on one widget
          for (let i = 0; i < this.config.tools.length; i++) {
            this.config.tools[i].position--;
            if (this.config.tools[i].position <= 0) {
              this.animateOff(i);
            } else if (this.config.tools[i].position === (this.numbVis)) {
              this.turnOn(i);
            }
          }
        }
      } else {
        // if last widget is turned off because of mobile
        this.goRight(this.config.tools.length - 2);
      }
    } else if (index > 0) {
      if (this.mobileOff(index)) {
        if (this.config.tools[index].visible === 'hidden') {
          for (let i = 0; i < this.config.tools.length; i++) {
            this.config.tools[i].position--;
            if (this.config.tools[i].position <= 0) {
              this.animateOff(i);
            } else if (this.config.tools[i].position === (this.numbVis)) {
              this.turnOn(i);
            }
          }
        }
      } else {
        this.goRight(index - 1);
      }
    }
    this.arrowToggle();
  }

  /**
   * Event binding that moves the widgets to the left on user click
   */
  public goLeft() {
    if (this.config.tools[0].visible === 'hidden') {
      for (let i = 0; i < this.config.tools.length; i++) {
        this.config.tools[i].position++;
        if (this.config.tools[i].position <= 0) {
          this.turnOff(i);
        } else if (this.config.tools[i].position === 1) {
          this.turnOn(i);
        }
        this.arrowToggle();
        if (this.config.tools[i].position > this.numbVis) {
          this.animateOff(i);
          for (let j = i + 1; j < this.config.tools.length; j++) {
            this.config.tools[j].position++;
          }
          this.arrowToggle();
          break;
        }
      }
    }
  }

  /**
   * Event binding for when a user clicks on a widget button
   * @param index: Widget index number for button clicked
   */
  public widgetClick(index) {
    if (this.config.tools[index].status === 'widget-off') {
      this.config.tools[index].status = 'widget-on';
      this.config.tools[index].grid = true;
      this.grid.widgetOn(this.config.tools[index].id);
    } else {
      this.config.tools[index].status = 'widget-off';
      this.config.tools[index].grid = false;
      this.grid.widgetOff(this.config.tools[index].id);
    }
  }

  /**
   * Removes/adds draw/measure/query/attribute table widget based on screen size
   */
  private fixForMobile() {
    if (this.mobileAr.length === 0) { this.mobileAr = this.config.tools.slice(0); }
    for (let i = this.config.tools.length - 1; i >= 0; i--) {
      if (!this.mobileOff(i)) {
        this.config.tools.splice(i, 1);
      }
    }
    let index = 1;
    for (let j = 0; j < this.config.tools.length; j++) {
      this.config.tools[j].position = j + 1;
      index = j + 1;
    }
    this.widgetNumb = index;
    this.targetWidth = this.widgetNumb * 55  + 80;
  }
  /**
   * Controls what widgets are turned off on mobile
   * @param index: Widget object index
   * @returns: returns boolean based off what is turned on/off
   */
  private mobileOff(index: number) {
    return (this.config.tools[index].id !== 'measurement' && this.config.tools[index].id !== 'draw'
      && this.config.tools[index].id !== 'attributes' && this.config.tools[index].id !== 'query'
      && this.config.tools[index].id !== 'bookmark'
      && this.config.tools[index].id !== 'addData' && this.config.tools[index].id !== 'reorder');
  }

  /**
   * Controls widget bar size and screen placement on init and when screen resizing event occurs
   * @param event: Screen resize event
   * @param flag: Flag variable for when the event is a window object (true), or a resize event (false)
   */
  public onResize(event: any, flag: boolean) {
    let maxWidth: number;
    if (this.config.tools && window.innerWidth <= 600 || window.innerHeight <= 600) {
      this.fixForMobile();
    } else {
      if (this.mobileAr.length > 0) {
        this.config.tools = this.mobileAr.slice(0);
        this.mobileAr = [];
      }
      if (this.config.tools) {
        this.widgetNumb = this.config.tools.length;
        this.targetWidth = this.widgetNumb * 55 + 80;
        let i = 1;
        for (const j of this.config.tools) {
          j.position = i;
          i++;
        }
      }
    }
    // checks to see if this is on init or not and returns correct window call
    if (flag) {
      maxWidth = event.innerWidth * .7;
    } else {
      maxWidth = event.target.innerWidth * .7;
    }
    // checks for window size and acts accordingly
    if (window.innerWidth <= 600 || window.innerHeight <= 600) {
      this.actualWidth = '90%';
      this.calcWidgetBar(maxWidth);
    } else if (this.targetWidth > maxWidth) {
      this.calcWidgetBar(maxWidth);
    } else {
      for (let i = 0; i < this.widgetNumb; i++) {
        if (this.config.tools[i].position) {
          this.turnOn(i);
        }
        if (this.config.tools[i].position <= 0) {
          for (let j = 0; j < this.widgetNumb; j++) {
            this.config.tools[j].position++;
          }
        }
      }
    }
    // keeps track of the previous window width
    this.oldWidth = window.innerWidth;

    // gets number of visible icons
    this.numbVis = 0;
    for (const widget of this.config.tools) {
      if (widget.visible === 'visible') {
        this.numbVis++;
      }
    }
    // sets position of the toolbar
    this.actualWidth = Math.round(this.numbVis * 55 + 15) + 'px';
    this.left = (window.innerWidth * .5) - ((parseInt(this.actualWidth, 10) + 66) * .5) + 'px';
    this.toolBarWidth = maxWidth + 'px';
    // determines if arrows should be visible
    this.arrowToggle();
    this.cd.detectChanges();
  }

  /**
   * Calculates the number of widgets that can fit on the bar based on the width given
   * @param maxWidth: Maximum width of the widget bar based on screen size
   */
  private calcWidgetBar(maxWidth: number) {
    const actualWidgetNumber = Math.floor((maxWidth - 40) / 55);
    let negativePositionFlag = false;
    for (let i = 0; i < this.config.tools.length; i++) {
      if (this.config.tools[i].position >= 0) {
        if (this.config.tools[i].position < actualWidgetNumber) {
          if (window.innerWidth <= 600 || window.innerHeight <= 600) {
            if (this.mobileOff(i)) {
              this.turnOn(i);
            } else {
              this.turnOff(i);
            }
          } else {
            this.turnOn(i);
          }
        } else {
          this.turnOff(i);
        }
      } else {
        negativePositionFlag = true;
      }
    }
    if (negativePositionFlag) {
      for (let i = this.config.tools.length - 1; i > 0; i--) {
        if (this.config.tools[i].position <= 0) {
          if (this.config.tools[this.config.tools.length - 1].position < actualWidgetNumber) {
            if (window.innerWidth <= 600 || window.innerHeight <= 600) {
              if (this.mobileOff(i)) {
                this.turnOn(i);
                for (const k of this.config.tools) {
                  if (this.mobileOff(i)) {
                    k.position++;
                  }
                }
              } else {
                this.turnOff(i);
              }
            } else {
              this.turnOn(i);
              for (const k of this.config.tools) {
                if (this.mobileOff(i)) {
                  k.position++;
                }
              }
            }
          } else {
            this.turnOff(i);
          }
        }
      }
    }
  }

  /**
   * Controls the css changes when a widget is visible on the bar
   * @param index: Index of the widget to be visible
   */
  private turnOn(index: number) {
    this.config.tools[index].width = '45px';
    this.config.tools[index].iconWidth = '20px';
    this.config.tools[index].padding = '10px';
    this.config.tools[index].margin = '5px';
    this.config.tools[index].visible = 'visible';
    this.config.tools[index].button = 'vis';
  }

  /**
   * Controls the css changes when a widget is visible on the bar
   * @param index: Index of the widget to be hidden
   */
  private turnOff(index: number) {
    this.config.tools[index].width = '0px';
    this.config.tools[index].iconWidth = '0px';
    this.config.tools[index].padding = '0px';
    this.config.tools[index].margin = '0px';
    this.config.tools[index].visible = 'hidden';
    this.config.tools[index].button = 'hid';
  }

  /**
   * Disables animation for a widget button
   * @param index: Index of the widget
   */
  private animateOff(index: number) {
    this.config.tools[index].width = '0px';
    this.config.tools[index].iconWidth = '0px';
    this.config.tools[index].padding = '0px';
    this.config.tools[index].margin = '0px';
    this.config.tools[index].visible = 'hidden';
    setTimeout(() => {
      this.config.tools[index].button = 'hid';
    }, 250);
  }

  /**
   * Calculates whether the arrows are usable given the size of the screen
   * @param index: Index of the widget in question
   */
  private arrowToggle(index?: number) {
    if (this.config.tools[0].position && this.config.tools[0].position > 0) {
      this.rightArrow = 0.5;
    } else {
      this.rightArrow = 1;
    }
    if (!index) {
      if ((window.innerWidth > 600 || window.innerHeight > 600)) {
        if (this.config.tools[this.config.tools.length - 1].position === this.numbVis) {
          this.leftArrow = 0.5;
        } else {
          this.leftArrow = 1;
        }
      } else if (this.mobileOff(this.config.tools.length - 1)) {
        if (this.config.tools[this.config.tools.length - 1].position === this.numbVis) {
          this.leftArrow = 0.5;
        } else {
          this.leftArrow = 1;
        }
      } else {
        this.arrowToggle(this.config.tools.length - 2);
      }
    } else {
      if (this.mobileOff(index)) {
        if (this.config.tools[index].position === this.numbVis) {
          this.leftArrow = 0.5;
        } else {
          this.leftArrow = 1;
        }
      } else {
        this.arrowToggle(index - 1);
      }
    }
    this.cd.detectChanges();
  }
}
